import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configOperations } from '../../../redux/config';
import { mapOperations } from '../../../redux/map';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RequiredFieldStatus from '../RequiredFieldStatus';
import EventNoteIcon from '@mui/icons-material/EventNote';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InitialResourcesDialog from '../InitialResourcesDialog'
import '../DetailsIncidentPanel.css';

class MultiAgencyResponsePanel extends Component {
  constructor(props) {

    super(props);
    this.state = {
      open: true,
      highlightRequiredFields: false,
      showInitialResources: false,
      primaryRequiredNullFields: [],
      requiredNullFields: [],
      derivingFields: [],
      secondaryRequiredNullFields: [],
      totalRequiredNullFields: null,
      requiredFields: props.requiredFields ? props.requiredFields : [],
      staticFields: props.staticFields ? props.staticFields : [],
      attributes: props.attributes,
      dependentFields: props.dependentFields ? props.dependentFields : []
    };
  }

  //TODO: Try to get rid of all componentWillReceiveProps
  componentWillReceiveProps(nextProps) {

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields === 0)
   {
     this.setState({
       open: false
     });
   }

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields > 0)
   {
     this.setState({
       open: true
     });
   }

    if (nextProps.expandAllPanels === true)
    {
      this.setState({
        open: true
      });
    }


   if(nextProps.requiredFields && this.props.requiredFields)
   {
     if (JSON.stringify({...nextProps.requiredFields}) !== JSON.stringify({...this.state.requiredFields}))
     {
       this.updateRequiredFields(nextProps.requiredFields);
     }
   }

  }

updateRequiredFields = (updatedRequiredFields) =>
{
  this.setState({
    requiredFields: updatedRequiredFields
  });
}

  highlightRequiredFields = () =>
  {
    const open = this.state.open || (this.state.secondaryRequiredNullFields.length > 0);
    this.setState({
      open,
      highlightRequiredFields: true
    }, () => {
      window.setTimeout(() => {
        this.setState({highlightRequiredFields: false})
      }, 1000);
    });
  }

  showInitialResources = () => {
    this.setState({showInitialResources: true});
  }

  hideInitialResources = () => {
    this.setState({showInitialResources: false});
  }

  accordionChange = (event) =>
  {
    this.setState({open: !this.state.open});
    this.props.resetPanelCollapseFlag();
  }

  updateAgencies = (code, isChecked)  =>
  {
      if (!isChecked)
      {
        this.props.removeInitialResponseAgency(code);
      }
      else
      {
        this.props.addInitialResponseAgency(code);
      }
  }

  render()
  {
    const showRadios = true;
    const resourceTooltip = (this.props.initialResources && this.props.initialResources.length > 0) ? (<Tooltip title="Initial Resources">
      <IconButton onClick={this.showInitialResources}>
        <EventNoteIcon />
      </IconButton>
    </Tooltip>) : "";

    let requiredFieldStatusNode = '';
    if (this.state.totalRequiredNullFields > 0)
    {
      requiredFieldStatusNode = (
        <RequiredFieldStatus
          chipClicked={this.highlightRequiredFields}
          missingFields={this.state.totalRequiredNullFields} />
      )
    }

    let title = (
      <div className="incident-details-panel-header">
        <h4>{this.props.title}</h4>
        <span className="required-field-node-class">{requiredFieldStatusNode}</span>
      </div>
    )

    const agencies = [
      { name: "BIA", label: "Bureau of Indian Affairs" },
      { name: "BLM", label: "Bureau of Land Management" },
      { name: "BOR", label: "Bureau of Reclamation" },
      { name: "DOD", label: "Department of Defense" },
      { name: "DOE", label: "Department of Energy" },
      { name: "NPS", label: "National Park Service" },
      { name: "USFS", label: "US Forest Service" },
      { name: "USFWS", label: "US Fish and Wildlife Service" },
      { name: "OthFed", label: "Other Federal" },
      { name: "Foreign", label: "Foreign Government" },
      { name: "Tribal", label: "Tribal Government (non-trust lands)" },
      { name: "City", label: "City or Equivalent Government" },
      { name: "County", label: "County or Equivalent Government" },
      { name: "State", label: "State or Equivalent Government" },
      { name: "Private", label: "Individual or Private Corporation" },
      { name: "ANCSA", label: "Alaska Native Claims Settlement Act" },
    ];

    //TODO: Rewrite this checkbox code
    return (
      <Accordion className="incident-details-panel" expanded={this.state.open} onChange={this.accordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
        <AccordionDetails>
        <InitialResourcesDialog open={this.state.showInitialResources} onClose={this.hideInitialResources} initialResources={this.props.initialResources}/>
        <div className="incident-details-panel-expander-top-align">

        <div className="detail-row" style={ (!showRadios) ? {display: 'none'} : {margin: 'auto'}}>
        <label className="detail-row-label" style={{minWidth:"200px"}}>Responding Agencies</label>{resourceTooltip}
        <div className="detail-row-value">
          <FormGroup style={{ marginLeft: "14px", marginTop: "0px" }}>
            {agencies.map(({ name, label }) => (
              <FormControlLabel
                key={name}
                control={
                  <Checkbox
                    name={name}
                    color="primary"
                    disabled={this.props.mode === "read"}
                    onChange={(event) =>
                      this.updateAgencies(name, event.target.checked ? 1 : 0)
                    }
                    checked={
                      this.props.attributes.InitialResponseAgencies?.includes(name)
                    }
                  />
                }
                label={label}
              />
            ))}
          </FormGroup>
        </div>
      </div>


        </div>
      </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...mapOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiAgencyResponsePanel)
